import Routes from "./routes";
import "antd/dist/reset.css";

function App() {
  return <Routes />;
}

export default App;
